module.exports = __webpack_public_path__ + "img/img-14.08842886.png";